<template>
    <csp-base-file-upload
        ref="fileUpload"
        v-bind="fileDropOnlyProps"
        :disabled="isDisabled"
        file-input-name="fileUpload"
        :multiple-upload="multipleUpload"
        :on-transform="onTransform"
        :title="$t('record document upload')"
        :upload-error-message="this.$t('record document upload error')"
        :upload-url="uploadUrl"
        @before-upload="handleBeforeUpload"
        @file-drop="(event) => $emit('file-drop', event)"
        @upload-complete="handleUploadComplete"
        @upload-disabled="handleDisabledUpload"
        @upload-reset="$emit('upload-reset')">
        <slot/>
    </csp-base-file-upload>
</template>

<script>
    import Container from '@services/Container';

    var container = Container.getInstance();
    const flashMessenger = container.getFlashMessenger();

    export default {
        props: {
            categoryGroup: {
                required: true,
                validator: prop => typeof prop === 'number' || prop === null,
            },
            category: {
                required: true,
                validator: prop => typeof prop === 'number' || prop === null,
            },
            fileDropOnly: {
                type: Boolean,
                default: false,
            },
            multipleUpload: {
                type: Boolean,
                default: false,
            },
            onTransform: {
                type: [Function, null],
                default: null,
            },
            recordId: {
                required: true,
                type: [Number, String],
            },
        },
        emits: [
            'file-drop',
            'upload-success',
            'upload-reset',
        ],
        data() {
            return {
                uploadNotificationSessionId: this.generateUploadNotificationSessionId(),
            }
        },
        computed: {
            fileDropOnlyProps() {
                if (!this.fileDropOnly) {
                    return {};
                }
                return {
                    onlyAllowDragAndDrop: true,
                    showMessage: false,
                    wrapperClasses: [],
                };
            },
            categoryId() {
                return this.category;
            },
            categoryGroupId() {
                return this.categoryGroup;
            },
            isDisabled() {
                return !(this.fileDropOnly || this.categoryId);
            },
            uploadUrl() {
                return '/de/Schaden-Manager/Akte/fileupload/vehicleDamageRecordId/' + this.recordId;
            },
        },
        methods: {
            generateUploadNotificationSessionId() {
                return 'upload-notification-' + Math.random().toString(36).substring(2, 15)
                    + Math.random().toString(36).substring(2, 15);
            },
            handleBeforeUpload(file, xhr, formData) {
                formData.append('name', file.name);
                formData.append('subformFileCategory[fileCategoryGroupId]', this.categoryGroupId);
                formData.append('subformFileCategory[fileCategory]', this.categoryId);
                formData.append('uploadNotificationSessionId', this.uploadNotificationSessionId);
            },
            handleDisabledUpload() {
                flashMessenger.addWarning(this.$t('record document upload error no category'));
            },
            handleUploadComplete(data, statistics) {
                this.$emit('upload-success', data);
                let translationKey = 'record document upload success';

                if (statistics.numberOfAddedFiles > 1) {
                    translationKey = translationKey + ' multiple';
                }

                if (statistics.numberOfSuccessfullyUploadedFiles === statistics.numberOfAddedFiles) {
                    flashMessenger.addSuccess(this.$t(translationKey, statistics))
                    return;
                }

                flashMessenger.addWarning(this.$t(translationKey, statistics));
            },
            reset() {
                this.$refs.fileUpload.reset();
                this.uploadNotificationSessionId = this.generateUploadNotificationSessionId();
            },
        },
    }
</script>
